import { GetRequest, PostRequest } from '@/api/base';

// eslint-disable-next-line import/prefer-default-export
export function resetPwdManage(params: any, callback: any) {
    PostRequest('v3/web/common/manage/resetPwd', params, callback);
}
